import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { IContactUpdateResource } from "../../shared/types";
import {
	PrimaryLabel,
	ViewPageSection,
	ViewPageSectionBody,
	ViewPageSectionHeader,
	ViewPageSectionListItemWrapper,
} from "../../shared/view";

const StyledViewPageSection = styled(ViewPageSection)`
	grid-area: email;
`;

export const ArchivedContactViewEmailAddressSection: FC<{ contact: IContactUpdateResource }> = ({ contact }) => {
	const { t } = useTranslation();

	return (
		<StyledViewPageSection>
			<ViewPageSectionHeader>{t("Email addresses")}</ViewPageSectionHeader>
			<ViewPageSectionBody>
				{contact.contactEmails.map((x) => (
					<ViewPageSectionListItemWrapper key={x.id}>
						{x.email} {x.isPrimary && <PrimaryLabel />}
					</ViewPageSectionListItemWrapper>
				))}
			</ViewPageSectionBody>
		</StyledViewPageSection>
	);
};
